/**
 *
 * StripesHeader
 *
 */

import React from 'react';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

function StripesHeader(props) {
  return (
    <div className="about-story__wrap subhdr-stripes subhdr-stripes--sub">
      <span className="stripes-bg" />
      {props.children}
    </div>
  );
}

StripesHeader.propTypes = {};

export default StripesHeader;
